import React, { useState } from 'react';

const Login = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            // ISPRAVLJENA ADRESA: Mora biti /core/login/ kao u curl testu
            const response = await fetch('/core/login/', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (response.ok && data.status === 'success') {
                // Šaljemo podatke u App.js da nas uloguje
                onLogin(data.username);
            } else {
                throw new Error(data.message || 'Neuspešna prijava!');
            }
        } catch (e) {
            setError(e.message);
        }
    };

    const inputStyle = { width: '100%', padding: '12px', marginBottom: '15px', backgroundColor: '#050a1a', border: '1px solid #1a2a4a', color: 'white', boxSizing: 'border-box' };

    return (
        <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#050a1a' }}>
            <div style={{ backgroundColor: '#0a132b', padding: '40px', borderRadius: '10px', width: '350px', border: '1px solid #3366ff', textAlign: 'center' }}>
                <h2 style={{ color: 'white', marginBottom: '30px' }}>EcoPell Teren</h2>
                
                {error && <div style={{ color: '#ff4d4d', marginBottom: '15px', fontSize: '14px' }}>{error}</div>}
                
                <form onSubmit={handleLogin}>
                    <input style={inputStyle} type="text" placeholder="Korisničko ime" value={username} onChange={e => setUsername(e.target.value)} required />
                    <input style={inputStyle} type="password" placeholder="Lozinka" value={password} onChange={e => setPassword(e.target.value)} required />
                    <button type="submit" style={{ width: '100%', padding: '12px', backgroundColor: 'white', color: '#1a2a4a', border: 'none', borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer' }}>PRIJAVI SE</button>
                </form>
            </div>
        </div>
    );
};

export default Login;